import React, { useState, useEffect, useContext  } from 'react';
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { deleteFinca, deleteCentroTrabajo, getFincasAAFF, cambiarFinca, UpdateSale, updateInstalacion } from '../../../services';
import { toast } from "react-toastify";
import { UsuarioContext } from "../../../providers/userContext";
import Swal from "sweetalert2";
import { Typography, Box, Select } from "@mui/material";
import { diferenciaMesesCaducidad, formatoFechasEs, ventaMasReciente, GRUPOS_SERVICIO } from "../../../functions/funciones";
import Delete from "../../../icons/delete.svg";
import Change from "../../../icons/change.svg";
import Add from "../../../icons/addBlack.svg";
import { DialogoCambioAAFF } from "../../../providers/Dialogos";
import { CustomSwitch } from "../../../components/Buttons/Switch";
import { DataTable } from '../../../components';
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from '../../../functions/parametrosURL/funcionesParamsURL';
import FiltrosComunidades from '../../../components/filtros/filtrosComunidades';

const ListadoComunidades = (props) => {
  const { t } = useTranslation(['properties', 'common']);
  const navigate = useNavigate();
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [isLoading, setIsloading] = useState(true);
  const [recargar, setRecargar] = useState(0);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  // const [fincas, setFincas] = useState([]);
  const [fincaCambiarAAFF, setFincaCambiarAAFF] = useState({});
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const [estados, setEstados] = useState([]);

  const user = useContext(UsuarioContext);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  useEffect(() => {
    fetchData();
  },[recargar, props.recargarExterno])

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy } = {}) => {
    
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    
    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order,orderBy);    

    setIsloading(true);

    if (props.aaff?.id) {
      const payload = {
        filtros: { ...filtros, aaff_id: props.aaff.id },
        params: { page: offset, limit, order,orderBy },
      };
      // Obtener estados del cache (localStorage)
      const estadosCache = JSON.parse(localStorage.getItem("states")) || [];
      setEstados(estadosCache);
      
      try {
        const response = await getFincasAAFF(payload)
        const { meta, data } = response || {};
        setData({
          meta: meta || {},
          rows: formatData(data),
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        setData({ meta: {}, rows: [] });
        toast.error(t('common:messages.error'));
      } finally {
        setIsloading(false);
        setRecargar(false);
      }
    } else {
      setIsloading(false);
    }
  }

    const formatData = (data) => {
        const formattedData = []
        if (!Array.isArray(data)) return formattedData;
        data.map((row) => {
          const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
          const sale_lopd = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.lopd);
          const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
          const instalacion_kae = row?.instalacionesKae?.find(i => i.prop_id === row.id) || null;
          // const diferenciaMeses = diferenciaMesesCaducidad(row.fechaRenovacion, row.createdAt);
          formattedData.push({
            razonSocial: row.razonSocial,
              nif: row.nif,
              nifAAFF: row.aaff.nif,
              createdAt: formatoFechasEs(row.createdAt),
              proveedores: sale_cae && row.proveedores !== 0 && row.proveedores !== false ? row.suppliers.filter(objeto => objeto.status === true).length : "No tiene",
              trabajadores: row.trabajadores === null ? false : row.trabajadores,
              activo: row.activo === null ? true : row.activo,
              direccion: row.direccion,
              codigoPostal: row.codigoPostal,
              municipio: row.municipio,
              provincia: row.provincia,
              estadoCae: sale_cae ? sale_cae.estado_id === null ? 1 : sale_cae.estado_id : "-",
              estadoLopd: sale_lopd ? sale_lopd.estado_id === null ? 1 : sale_lopd.estado_id : "-",
              estadoCai: sale_cai ? sale_cai.estado_id === null ? 1 : sale_cai.estado_id : "-",
              estadoKae: instalacion_kae ? instalacion_kae.estado_id : "-",
              ct: row.nif,
              cambiar: row,
              eliminar: row,
              isWorkcenter: false, // Not a workcenter
              // caducada: diferenciaMeses > 13 ? true : false,
              saleCae_id: sale_cae?.id || null,
              saleLopd_id: sale_lopd?.id || null,
              saleCai_id: sale_cai?.id || null,
              instalacionKae_id: instalacion_kae ? instalacion_kae.id : null,
          })
          if (row.workcenters?.length > 0) {
              row.workcenters?.forEach((wc) => {
                  formattedData.push({
                      razonSocial: wc.razonSocial,
                      nif: "",
                      nifAAFF: row.aaff.nif,
                      createdAt: !isNaN(wc.createdAt) ? formatoFechasEs(wc.createdAt) : "",
                      ct: "",
                      cambiar: "",
                      eliminar: wc,
                      isWorkcenter: true,
                      trabajadores: "",
                      codigoPostal: "",
                      municipio: "",
                      provincia: "",
                      activo: "",
                      estadoCae: "",
                      estadoLopd: "",
                      estadoCai: "",
                      estadoKae: "",
                      saleCae_id: "",
                      saleLopd_id: "",
                      saleCai_id: "",
                      instalacionKae_id: "",
                  });
              });
          }
        });
        return formattedData;
    };
      
    const handleChangeActivo = (evt, nif) => {        
        const actualizarEstado = data.rows.map((row) => {
          if (row.nif === nif) {
            cambiarFinca(nif, {
              activo: evt.target.value
            })
            return { ...row, activo: evt.target.value === 'true' };
    
          }
          return row;
        });
        setData({ ...data, rows: actualizarEstado });
    };
    const handleChangeEstado = (evt, id, serv) => {
      const valor = parseInt(evt.target.value)
      // Mapeo serv → claves del row y endpoint. KAE usa updateInstalacion (tabla
      // instalacionesKae); el resto usan UpdateSale (tabla sales). Para añadir un
      // servicio nuevo, sumar una entrada aquí.
      const claves = {
        cae:  { idKey: 'saleCae_id',         estado: 'estadoCae',  update: UpdateSale },
        lopd: { idKey: 'saleLopd_id',        estado: 'estadoLopd', update: UpdateSale },
        cai:  { idKey: 'saleCai_id',         estado: 'estadoCai',  update: UpdateSale },
        kae:  { idKey: 'instalacionKae_id',  estado: 'estadoKae',  update: updateInstalacion },
      };
      const config = claves[serv];
      if (!config) return;
      const actualizarEstado = data.rows.map((row) => {
        const registro_id = row[config.idKey];
        if (registro_id === id) {
          config.update(id, { estado_id: valor });
          return { ...row, [config.estado]: valor };
        }
        return row;
      });
      // console.log(actualizarEstado)
      setData({ ...data, rows: actualizarEstado });
      // const updatedMainArray = data.rows.map(item => {
      //   if (item.sales) {
      //     const updatedNestedArray = item.sales.map(sale => {
      //       if (sale.id === id) {
      //         // console.log({ ...sale, estado_id: evt.target.value })
      //         const nuevosDatos = serv === "cae" ? {estadoCae:evt.target.value} : {estadoLopd:evt.target.value}
      //         return { ...sale, ...nuevosDatos };
      //       }
      //       return sale;
      //     });
      //     // console.log(updatedNestedArray)
      //     // // Devolvemos el item principal con el nestedArray modificado
      //     return { ...item, sales: updatedNestedArray };
      //   }
      //   return item;
      // });
      // console.log(updatedMainArray)
      // setData({ ...data, rows: updatedMainArray });
    };

    const handleChangeTrabajadores = (evt, nif) => {        
      const actualizarEstado = data.rows.map((row) => {
        if (row.nif === nif) {
          cambiarFinca(nif, {
            trabajadores: evt.target.value
          })
          return { ...row, trabajadores: evt.target.value === 'true' };
  
        }
        return row;
      });
      setData({ ...data, rows: actualizarEstado });
    };

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.community'),
      overrideFunc: (data, row) => (
            row.isWorkcenter === false ?
          <Link to={"/aaff/" + row.nifAAFF + "/comunidades/" + row.nif}>
            {data}
          </Link>
            :
              <Typography style={{ textAlign: 'left'}}>
                {data}
              </Typography>
      )
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
      overrideFunc: (data, row) => (
            row.isWorkcenter === false ?
          <Link to={"/aaff/" + row.nifAAFF + "/comunidades/" + row.nif}>
            {data}
          </Link>
            :
              <Typography style={{ textAlign: 'left'}}>
                {data}
              </Typography>
      )
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: t('columns.createdAt'),
      overrideFunc: (data, row) => (
        <Typography style={{ textAlign: 'left' }}>
          {data}
        </Typography>
      ),
    },
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "proveedores",
      numeric: false,
      disablePadding: false,
      label: t('columns.suppliers'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        // /aaff/:nifAAFF/comunidades/:nifFinca/proveedores
        <Link to={"/aaff/" + row.nifAAFF + "/comunidades/" + row.nif + "/proveedores"}>
          {row.proveedores}
        </Link>
      )
    },
    {
      id: "estadoCae",
      numeric: false,
      disablePadding: false,
      label: t('columns.caeStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
          data !== "-" ?
            <div className="activoSelect">
              <Select 
                  label={t('edit.fields.caeStatus')}
                  native 
                  name="estadoCae" 
                  id="estadoCae" 
                  style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data === 1 || null ? "#3eae3e" : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}
                  onChange={(event) => handleChangeEstado(event, row.saleCae_id, 'cae')} defaultValue={data}
                >
                  {estados?.map((e, i) => {
                    return (
                      <option key={i} value={e.id} style={{ color: e.id === 1 || e.id == null ? "#3eae3e"  : e.id === 2 || e.id === 3 ? '#FF8300' : e.id === 4 || e.id === 5 ? "#EE4534" : "#000" }}>
                        {t(`common:stateNames.${e.nombre}`, e.nombre)}
                      </option>
                    );
                  })}
                </Select>
            </div>
          : data
        : ""
      ),
    },
    {
      id: "estadoLopd",
      numeric: false,
      disablePadding: false,
      label: t('columns.lopdStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
          data !== "-" ?
            <div className="activoSelect">
              <Select 
                  label={t('edit.fields.lopdStatus')}
                  native 
                  name="estadoLopd" 
                  id="estadoLopd" 
                  style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data === 1 || null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}
                  onChange={(event) => handleChangeEstado(event, row.saleLopd_id, 'lopd')} defaultValue={data}
                >
                  {estados?.map((e, i) => {
                    return (
                      <option key={i} value={e.id} style={{ color: e.id === 1 || e.id == null ? "#3eae3e"  : e.id === 2 || e.id === 3 ? '#FF8300' : e.id === 4 || e.id === 5 ? "#EE4534" : "#000" }}>
                        {t(`common:stateNames.${e.nombre}`, e.nombre)}
                      </option>
                    );
                  })}
                </Select>
            </div>
          : data
        : ""
      ),
    }]: []),
    ...(user.rol === "ADMIN_CAI" ? [
      {
        id: "direccion",
        numeric: false,
        disablePadding: false,
        label: t('columns.address'),
      },
      {
        id: "codigoPostal",
        numeric: false,
        disablePadding: false,
        label: t('fields.postalCode').toUpperCase(),
      },
      {
        id: "municipio",
        numeric: false,
        disablePadding: false,
        label: t('columns.municipality'),
      },
      {
        id: "provincia",
        numeric: false,
        disablePadding: false,
        label: t('common:form.province').toUpperCase(),
      },
    ] : []),
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "estadoCai",
      numeric: false,
      disablePadding: false,
      label: t('columns.caiStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
          data !== "-" ?
            <div className="activoSelect">
              <Select 
                  label={t('edit.fields.caiStatus')}
                  native 
                  name="estadoCai" 
                  id="estadoCai" 
                  style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data === 1 || null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}
                  onChange={(event) => handleChangeEstado(event, row.saleCai_id, 'cai')} defaultValue={data}
                >
                  {estados
                  ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                  .map((e, i) => {
                    return (
                      <option key={i} value={e.id} style={{ color: e.id === 1 || e.id == null ? "#3eae3e"  : e.id === 2 || e.id === 3 ? '#FF8300' : e.id === 4 || e.id === 5 ? "#EE4534" : "#000" }}>
                        {t(`common:stateNames.${e.nombre}`, e.nombre)}
                      </option>
                    );
                  })}
                </Select>
            </div>
          : data
        : ""
      ),
    }] : [
      {
        id: "estadoCai",
        numeric: false,
        disablePadding: false,
        label: t('columns.caiStatus'),
        noObjeto:true,
        overrideFunc: (data, row) => {
          if (row.isWorkcenter || data === "-") return "";
          const estado = estados?.find((e) => e.id === Number(data));
          return estado ? (
            <span style={{ fontSize: '11px', color: estado.id === 1 || estado.id == null ? "#3eae3e" : estado.id === 2 || estado.id === 3 ? '#FF8300' : estado.id === 4 || estado.id === 5 ? "#EE4534" : "#000" }}>
              {t(`common:stateNames.${estado.nombre}`, estado.nombre)}
            </span>
          ) : data;
        },
      }
    ]),
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "estadoKae",
      numeric: false,
      disablePadding: false,
      label: t('columns.kaeStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
          data !== "-" ?
            <div className="activoSelect">
              <Select 
                  label={t('edit.fields.kaeStatus')}
                  native 
                  name="estadoKae" 
                  id="estadoKae" 
                  style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data === 1 || null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}
                  onChange={(event) => handleChangeEstado(event, row.instalacionKae_id, 'kae')} defaultValue={data}
                >
                  {estados
                  ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                  .map((e, i) => {
                    return (
                      <option key={i} value={e.id} style={{ color: e.id === 1 || e.id == null ? "#3eae3e"  : e.id === 2 || e.id === 3 ? '#FF8300' : e.id === 4 || e.id === 5 ? "#EE4534" : "#000" }}>
                        {t(`common:stateNames.${e.nombre}`, e.nombre)}
                      </option>
                    );
                  })}
                </Select>
            </div>
          : data
        : ""
      ),
    },
    // {
    //   id: "activo",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "ACTIVO",
    //   overrideFunc: (data, row) => (
    //     data !== "" ?
    //       <div className="activoSelect">
    //         <Select 
    //             label="Activo"
    //             native 
    //             name="activo" 
    //             id="activo" 
    //             style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data ? "green" : 'red' }} 
    //             onChange={(event) => handleChangeActivo(event, row.nif)} value={data}
    //           >
    //             <option value={true}>Sí</option>
    //             <option value={false}>No</option>
    //           </Select>
    //       </div>
    //     : ""
    //   ),
    // },
    {
      id: "trabajadores",
      numeric: false,
      disablePadding: false,
      label: t('columns.employees'),
      overrideFunc: (data, row) => (
        data !== "" ?
          <div className="trabajadoresSelect">
            <Select
                label={t('fields.employees')}
                native
                name="trabajadores"
                id="trabajadores"
                style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data ? "green" : 'red' }}
                onChange={(event) => handleChangeTrabajadores(event, row.nif)} value={data}
              >
                <option value={true}>{t('common:status.yes')}</option>
                <option value={false}>{t('common:status.no')}</option>
              </Select>
          </div>
        : ""
      ),
    },
    {
      id: "ct",
      numeric: false,
      disablePadding: false,
      label: t('columns.addWorkCenter'),
      noObjeto:true,
      overrideFunc: (data, row) =>
        data !== "" ?
          <Link to={"/comunidades/" + row.nif + "/nuevoCentro"}>
            <img
              src={Add}
              alt={t('actions.addWorkCenter')}
              className="tableIcon"
              style={{margin:0}}
            />
          </Link>
          : null
    },
    {
      id: "cambiar",
      numeric: false,
      disablePadding: false,
      label: t('columns.changeAaff'),
      noObjeto:true,
      overrideFunc: (data, row) =>
        data !== "" ?
          <img
            src={Change}
            alt={t('columns.changeAaff')}
            className="tableIcon"
            style={{margin:0}}
            onClick={() => mostrarPanel(true, row)}
          ></img>
          : null
    },
    {
      id: "baja",
      numeric: false,
      disablePadding: false,
      label: t('columns.deactivate'),
      noObjeto:true,
      overrideFunc: (data, row) =>
      (
        row.isWorkcenter ? (
          <img
            src={Delete}
            alt={t('columns.deactivate')}
            className="tableIcon"
            style={{margin:0}}
            onClick={() => eliminarCentroTrabajo(row.eliminar)}
          ></img>
        ) : (
          <img
            src={Delete}
            alt={t('columns.deactivate')}
            className="tableIcon"
            style={{margin:0}}
            onClick={() => bajaFinca(row.eliminar)}
          ></img>
        )
      )

    }] : []),
  ];
  const mostrarPanel = (opened, finca) => {
    setOpen(opened);
    setFincaCambiarAAFF(finca);
  };

  function bajaFinca(f) {
    Swal.fire({
      title: t('confirmations.deactivateProperty', { name: f.razonSocial }),
      showCancelButton: true,
      cancelButtonText: t('common:actions.cancel'),
      confirmButtonText: t('confirmations.deactivate'),
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteFinca(f.nif)
          .then((res) => {
            if (res.message === "PROPERTIE_DELETED") {
              toast.success(t('confirmations.deactivatedSuccess'));
              setRecargar(!recargar);
            } else {
              toast.error(t('confirmations.deactivateError'));
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('confirmations.deactivateError'));
          });
      }
    });
  }

  function eliminarCentroTrabajo(f) {
    Swal.fire({
      title: t('confirmations.deactivateProperty', { name: f.razonSocial }),
      showCancelButton: true,
      cancelButtonText: t('common:actions.cancel'),
      confirmButtonText: t('confirmations.deactivate'),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCentroTrabajo(f.id)
          .then((res) => {
            toast.success(t('confirmations.workCenterDeleted'));
            setRecargar(!recargar);
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('confirmations.workCenterDeleteError'));
          });
        }
      })
    }
    const hijoAPadre = (datosHijo) => {
        setRecargar(datosHijo);
    };

    const filtrarDatos = (filtros) => {
      setBusqueda(filtros);
    };

    const clearFilters = () => {
      if (user.rol === "CONSUL" && primeraCarga) {
        setBusqueda({
          ...busqueda,
          consul_id: user.id 
        });
        setPrimeraCarga(false);
      }
      else{
        setBusqueda({});
      }
      
      setClearFilterActivo(true);
    }
    return (
        <>
            <FiltrosComunidades onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} ocultarFiltroAaff={!!props.aaff?.id} />
            <div className="tableWrapper">
            <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                <DataTable
                    data={data.rows}
                    isLoading={isLoading}
                    headers={comunidadesRows}
                    fetcher={fetchData}
                    currentPage={data.current_page}
                    meta={data.meta}
                    totalItems={data.total}
                    totalPages={data.totalPages}
                    nextPage={data.next_page}
                    filtros={busqueda}
                    clearFilterActivo={clearFilterActivo}
                    setClearFilterActivo={setClearFilterActivo}
                    mensaje={t('noCommunities')}
                    enumerate={true}
                    // propCaducada={true}
                />
                </Box>
            </Box>
            </div>
            {open && (
                <DialogoCambioAAFF
                    open={open}
                    setOpen={setOpen}
                    finca={fincaCambiarAAFF}
                    aaff={props.params.nif}
                    tipo={"cambiar"}
                    hijoAPadre={hijoAPadre}
                />
            )}
            <style jsx="true">{`
              #trabajadores, #activo, #estadoCae, #estadoLopd, #estadoCai, #estadoKae{
                padding:0 25px 0 0;
                border: none;
              }
              #estadoCai, #estadoKae{
                width: auto !important;
              }
              .trabajadoresSelect fieldset, .trabajadoresSelect select:hover, .activoSelect fieldset, .activoSelect select:hover{
                border-color: rgba(0, 0, 0, 0) !important;
              }               
          `}</style>
        </>
    )
}
export default withRouter(ListadoComunidades);